/**
 * Seat styling constants - centralized color and style definitions
 */
export const SEAT_COLORS = {
  available: {
    fill: '#e3f2fd', // light blue
    stroke: '#1F473E',
    strokeWidth: 1,
    opacity: 1,
  },
  occupied: {
    fill: '#bdbdbd', // gray instead of light red
    stroke: '#757575', // gray border
    strokeWidth: 1,
    opacity: 0.6,
  },
  blocked: {
    fill: '#bdbdbd', // gray
    stroke: '#757575', // gray border
    strokeWidth: 1,
    opacity: 0.6,
  },
  booked: {
    fill: '#bdbdbd', // gray - same as blocked
    stroke: '#757575', // gray border - same as blocked
    strokeWidth: 1,
    opacity: 0.6,
  },
  selected: {
    fill: '#4caf50', // green
    stroke: '#2e7d32',
    strokeWidth: 2,
    opacity: 1,
  },
} as const;

export const SEAT_HOVER_COLORS = {
  available: {
    strokeWidth: 1,
    stroke: '#1F473E',
    filter: 'brightness(1.1)',
  },
  selected: {
    strokeWidth: 2,
    stroke: '#2e7d32',
    filter: 'brightness(0.95)',
  },
} as const;

export const SECTION_COLORS = {
  default: {
    stroke: '#666',
    strokeWidth: 1,
    fill: 'none',
  },
  fullySelected: {
    stroke: '#4caf50',
    strokeWidth: 1,
    fill: 'rgba(5, 7, 5, 0.1)',
  },
} as const;

